var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { Icon } from './icon';
import { classNames } from '@shapeable/utils';
import { useLang } from '../hooks/use-lang';
import { useLink } from '../hooks/use-link';
import { HTML } from './html';
import { useComponentPropsFor } from '../context/component-props-context';
var cls = classNames('menu-item');
export var MenuItemDefaultProps = {
  iconSize: 32,
  patchLang: true,
  colors: {
    text: 'strong',
    bold: 'strong',
    background: 'bright',
    fill: 'strong',
    hover: {
      background: 'primary',
      text: 'bright'
    },
    active: {
      text: 'primary',
      background: 'bright'
    }
  }
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-size: 1em;\n    cursor: pointer;\n    display: flex;\n    cursor: pointer;\n\n    ", "\n    \n    \n    button, a {\n      ", ";\n      text-decoration: none;\n      font-size: 1em;\n      cursor: pointer;\n      display: flex;\n      align-items: center;\n      font-family: ", ";\n      display: flex;\n      width: 100%;\n    }\n\n\n    ", "\n\n    ", "\n  "], ["\n    font-size: 1em;\n    cursor: pointer;\n    display: flex;\n    cursor: pointer;\n\n    ", "\n    \n    \n    button, a {\n      ", ";\n      text-decoration: none;\n      font-size: 1em;\n      cursor: pointer;\n      display: flex;\n      align-items: center;\n      font-family: ", ";\n      display: flex;\n      width: 100%;\n    }\n\n\n    ", "\n\n    ", "\n  "])), function (_a) {
    var _b;
    var colors = _a.colors,
      isActive = _a.isActive;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      ", ";\n      ", ";\n\n      .shp--text-bubble {\n        color: ", ";\n        background: ", ";\n      }\n    "], ["\n      ", ";\n      ", ";\n\n      .shp--text-bubble {\n        color: ", ";\n        background: ", ";\n      }\n    "])), theme.APPLY_COLORS({
      colors: colors,
      isActive: isActive,
      selector: cls.child('body')
    }), theme.APPLY_COLORS({
      colors: colors,
      isActive: isActive
    }), theme.COLOR(colors.background), theme.COLOR(isActive ? (_b = colors.active) === null || _b === void 0 ? void 0 : _b.text : colors.text));
  }, theme.REMOVE_BUTTON_STYLE(), theme.FONT('sans'), function (_a) {
    var isActive = _a.isActive;
    return isActive && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      button, a {\n        cursor: default;\n      }\n    "], ["\n      button, a {\n        cursor: default;\n      }\n    "])));
  }, function (_a) {
    var isDisabled = _a.isDisabled;
    return isDisabled && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n       button, a {\n        cursor: default;\n        opacity: 0.7;\n       }\n    "], ["\n       button, a {\n        cursor: default;\n        opacity: 0.7;\n       }\n    "])));
  })
});
var ButtonStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var BodyStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    display: flex;\n    width: 100%;\n    box-sizing: border-box;\n    justify-content: flex-start;\n    align-items: center;\n    text-decoration: none;\n    padding: ", " ", " ", " ", ";\n  "], ["\n    display: flex;\n    width: 100%;\n    box-sizing: border-box;\n    justify-content: flex-start;\n    align-items: center;\n    text-decoration: none;\n    padding: ", " ", " ", " ", ";\n  "])), theme.UNIT(2), theme.UNIT(6), theme.UNIT(2), theme.UNIT(4))
});
var PictureStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    flex-shrink: 0;\n    margin-right: ", ";\n  "], ["\n    flex-shrink: 0;\n    margin-right: ", ";\n  "])), theme.UNIT(3))
});
var LabelStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["  \n    color: inherit;\n    font-weight: 400;\n    text-transform: inherit;\n    white-space: nowrap;\n  "], ["  \n    color: inherit;\n    font-weight: 400;\n    text-transform: inherit;\n    white-space: nowrap;\n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'MenuItem',
  Container: styled.span(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Button: styled.button.attrs(cls.attr('button'))(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ButtonStyles),
  Body: styled.span.attrs(cls.attr('body'))(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Label: styled.span.attrs(cls.attr('label'))(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Icon: styled(Icon).attrs(cls.attr('icon'))(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), PictureStyles),
  Image: styled.span.attrs(cls.attr('image'))(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), PictureStyles)
};
export var MenuItem = function (props) {
  var _a = useComponentPropsFor(My.NAME, MenuItemDefaultProps, props),
    className = _a.className,
    onClick = _a.onClick,
    colors = _a.colors,
    iconSize = _a.iconSize,
    href = _a.href,
    isDisabled = _a.isDisabled,
    image = _a.image,
    target = _a.target,
    isActive = _a.isActive,
    label = _a.label,
    patchLang = _a.patchLang;
  var Link = useLink().Link;
  var t = useLang();
  var handleClick = !isDisabled && onClick ? function (e) {
    e.stopPropagation();
    e.preventDefault();
    onClick(e);
  } : null;
  var Icon = props.iconComponent;
  var body = React.createElement(My.Body, {
    colors: colors,
    isDisabled: isDisabled,
    isActive: isActive
  }, image ? React.createElement(My.Image, null, props.image) : Icon && React.createElement(My.Icon, {
    size: iconSize
  }, React.createElement(Icon, null)), React.createElement(My.Label, null, React.createElement(HTML, {
    text: t(label)
  })));
  var Button = props.buttonComponent || My.Button;
  return React.createElement(My.Container, {
    isActive: isActive,
    colors: colors,
    isDisabled: isDisabled,
    role: "button",
    className: cls.name(className)
  }, href && !isDisabled ? React.createElement(Link, {
    patchLang: patchLang,
    target: target,
    href: href
  }, body) : React.createElement(Button, {
    onClick: isDisabled ? function () {} : handleClick
  }, body));
};
MenuItem.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14;
// MenuItem.defaultProps = MenuItemDefaultProps;